export default "__VITE_ASSET__19386d55__"